module.exports = __webpack_public_path__ + "img/onedegree.101c2032.png";